module.exports = __webpack_public_path__ + "img/hudongyouxi.106b2582.png";